import { authApi } from './authService';

export interface TrackingPlatform {
  id: number;
  name: string;
  slug: string;
  isActive: boolean;
}

export interface TrackingVideo {
  id: string;
  name: string;
}

export interface TrackingIntegration {
  id_integration: string;
  id_video: string | null;
  id_plataform: number;
  platform_name: string;
  logo_url: string;
  webhook_url: string;
  token_plataform: string | null;
  is_active: boolean;
  has_first_sail: boolean;
  video_name: string | null;
  total_conversions: number;
  total_revenue: number;
  average_ticket: number;
  conversion_rate: number;
}

export interface TrackingData {
  plataforms: TrackingPlatform[];
  videos: TrackingVideo[];
  integrations: TrackingIntegration[];
}

export interface TrackingMetricsByDay {
  date: string;
  platformName: string | null;
  platformLogo: string | null;
  videoName: string | null;
  conversions: number;
  revenue: number;
  conversionRate: number;
  averageTicket: number;
}

export interface CreateTrackingPayload {
  userId: string;
  plataformId: number;
  videoId?: string;
  plataformToken?: string;
}

export interface CreateTrackingResponse {
  id: string;
  webhookUrl: string;
  isActive: boolean;
  hasFirstSail: boolean;
  createdAt: string;
  updatedAt: string;
}

/**
 * Busca dados necessários para criação de tracking
 * Retorna plataformas de conversão e vídeos do usuário
 * Token JWT é enviado automaticamente via interceptor
 */
export async function getTrackingData(
  token: string,
  startDate?: string,
  endDate?: string,
): Promise<TrackingData> {
  try {
    const response = await authApi.get('/conversions/tracker/data', {
      params: startDate && endDate ? { startDate, endDate } : undefined,
    });
    return response.data.data;
  } catch (error) {
    console.error('Erro ao buscar dados de tracking:', error);
    throw error;
  }
}

/**
 * Cria uma nova integração de tracking
 * Token JWT é enviado automaticamente via interceptor
 */
export async function createTracking(
  payload: CreateTrackingPayload,
  token: string
): Promise<CreateTrackingResponse> {
  try {
    const response = await authApi.post('/conversions/tracker/create', payload);
    return response.data.data;
  } catch (error) {
    console.error('Erro ao criar tracking:', error);
    throw error;
  }
}

/**
 * Busca métricas de rastreamento por dia dentro de um período
 * Token JWT é enviado automaticamente via interceptor
 */
export async function getTrackingMetricsByDay(
  token: string,
  startDate: string,
  endDate: string
): Promise<TrackingMetricsByDay[]> {
  try {
    const response = await authApi.get('/conversions/tracker/metrics-by-day', {
      params: { startDate, endDate },
    });
    return response.data.data;
  } catch (error) {
    console.error('Erro ao buscar métricas por dia:', error);
    throw error;
  }
}

/**
 * Deleta uma integração de tracking
 * Token JWT é enviado automaticamente via interceptor
 */
export async function deleteTracking(
  integrationId: string,
  token: string
): Promise<void> {
  try {
    await authApi.delete(`/conversions/${integrationId}`);
  } catch (error) {
    console.error('Erro ao deletar tracking:', error);
    throw error;
  }
}
